import $ from '@nuskin/nuskinjquery';
import {AuthenticationService, UserService} from '@nuskin/ns-account';
import {storage} from '@nuskin/ns-util';
import AdrService from './adr/AdrService';
import {PriceType} from '@nuskin/ns-product-lib';
import {getCachedConfigField} from '@nuskin/configuration-sdk';

/**
 *
 * ShopContextService
 *
 * @namespace ShopContextService
 */
let ECOM3_STORAGE_KEY = 'shopContext';

let getEcom3Cookie = function() {
    return $.cookie(ECOM3_STORAGE_KEY);
};

let setEcom3Cookie = function(value) {
    $.cookie(ECOM3_STORAGE_KEY, value, {path:'/'});
};

let getPriceType = (isAdr, _user) => {
    const user = _user || UserService.getUser();
    const isRetail =
        !getCachedConfigField('showWholeSalePricing') && (
            !AuthenticationService.isLoggedIn() ||
            !user ||
            user.priceType == 'RTL' ||
            user.isCustomer() ||
            user.isGuest
        );

    let priceType;

    if (isAdr || AdrService.isAdrOverride()) {
        if (isRetail) {
            priceType = PriceType.WADR;
        } else {
            // hardcoding months to 7 because only one market differentiates between wadwd and wadw in the cart for now -
            // if that changes will need to make a config
            if (user &&
                AdrService.getAdrMonths(storage.getItem(storage.metadata.ADR_CURRENT_ID)) >= 7 && getCachedConfigField('eligibleWADWD')) {
                priceType = PriceType.WADWD;
            } else {
                priceType = PriceType.WADW;
            }
        }
    } else {
        if (isRetail) {
            priceType = PriceType.WRTL;
        } else {
            priceType = PriceType.WWHL;
        }
    }

    return priceType;
};

let showPsv = (accountType) => {
    let user,
        showPsv = false;

    if (!accountType) {
        user = UserService.getUser();
        accountType = user ? user.accountType : 0;
    }

    // Only show PSV for distributors
    if (accountType == 10) {
        showPsv = true;
    } else if (accountType == 30 && getCachedConfigField('showPsvForPfc')) {
        showPsv = true;
    }
    return showPsv;
};

export default {
    getEcom3Cookie,
    setEcom3Cookie,
    getPriceType,
    showPsv
};
